import { Component, OnInit } from '@angular/core';
import {PrimeNGConfig} from "primeng/api";
import {AuthService} from "../_services/auth_service";
import {TranslateService} from "@ngx-translate/core";
import {LanguageService} from "../_services/language_service";
import {IdleService} from "../_services/idle_service";
import {IdleTriggerService} from "../_services/idle_trigger_service";
import {Router} from "@angular/router";
import {RecaptchaService} from "../_services/recaptcha_service";

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.css']
})
export class CookieBannerComponent implements OnInit {
  isVisible = false;          // mostra il banner classico
  showSettingsToggle = false; // mostra la linguetta

  constructor(private recapchaService: RecaptchaService) {
  }

  ngOnInit(): void {
    const consent = localStorage.getItem('cookie-consent');
    if (consent === null) {
      this.isVisible = true;
      this.showSettingsToggle = false;
    } else {
      this.isVisible = false;
      this.showSettingsToggle = true;
    }
  }

  acceptCookies(): void {
    localStorage.setItem('cookie-consent', 'true');
    this.isVisible = false;
    this.showSettingsToggle = true;
    window.dispatchEvent(new Event('cookie-consent-updated'));
    this.recapchaService.loadRecaptcha();
  }

  denyCookies(): void {
    localStorage.setItem('cookie-consent', 'false');
    this.isVisible = false;
    this.showSettingsToggle = true;
    window.dispatchEvent(new Event('cookie-consent-updated'));
    location.reload();
    //this.recapchaService.removeRecaptchaArtifacts();
  }

  resetConsent(): void {
    localStorage.removeItem('cookie-consent');
    this.isVisible = true;
    this.showSettingsToggle = false;
  }

}
